/**
 * Middleware to check if the session has timed out and redirect to login if necessary.
 * This prevents users from navigating within the app after their session has expired.
 */

export default async function checkSessionTimeout(to, from, next) {
    const sessionMonitor = window.SessionMonitor;

    // Snapshot the in-flight destination so a 401 is not decided from a stale
    // currentRoute (or `/` while home is still the confirmed page).
    if (sessionMonitor?.rememberNavigation && !sessionMonitor.isAuthEntryPath?.(to.path)) {
        sessionMonitor.rememberNavigation(to.fullPath);
    }

    if (sessionMonitor?.isAuthEntryPath?.(to.path)) {
        return next();
    }

    // Get the store
    const store = window.$nuxt?.$store || window.$store;
    if (!store) {
        return next();
    }

    // Check if session has timed out
    const isSessionTimedOut =
        store.state.Auth?.sessionTimedOut || (sessionMonitor && sessionMonitor.isSessionTimedOut());

    if (isSessionTimedOut) {
        // Save the intended destination to return after login
        if (to.path && !sessionMonitor?.isAuthEntryPath?.(to.path)) {
            store.dispatch('Auth/saveReturnPath', to.fullPath);
        }

        // Redirect via SessionMonitor so return URL + session_expired notice stay consistent
        if (sessionMonitor) {
            sessionMonitor.redirectToLogin();
        } else {
            window.location.replace('/login');
        }
        return next(false); // Abort the current navigation
    }

    return next();
}
